module.exports = __webpack_public_path__ + "static/media/outdoor.494e963e.svg";